import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayWeek extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayWeek {
    return this.instance ? this.instance : (this.instance = new this());
  }
  private static instance: TEDDisplayWeek;

  public mode() {
    return TEDParseDateTimeMode.pdmYW;
  }
}

export { TEDDisplayWeek };
